export default __webpack_public_path__ + "static/media/questionnaire.e8d2f756.svg";